import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Zoom from '@mui/material/Zoom';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { boxShadowsToDropShadows } from 'themes/createTheme';
import { makeStyles } from 'tss-react/mui';

const arrowSize = 10;
const borderRadius = 20;

const useStyles = makeStyles()((theme, { dark }) => ({
  popper: {
    zIndex: theme.zIndex.modal,
    filter: boxShadowsToDropShadows(theme.shadows[16]),
    backgroundColor: dark ? theme.palette.icon.dark : theme.palette.background.paper,
    color: dark ? theme.palette.text.contrastText : theme.palette.text.primary,
    borderRadius,
    '&[data-popper-placement*="left"] .arrow': {
      right: 0,
      marginRight: -arrowSize - arrowSize + 1,
      marginTop: borderRadius,
      marginBottom: borderRadius,
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[data-popper-placement*="top"] .arrow': {
      bottom: 0,
      marginBottom: -arrowSize - arrowSize + 1,
      // marginLeft: borderRadius,
      // marginRight: borderRadius,
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[data-popper-placement*="right"] .arrow': {
      left: 0,
      marginLeft: -arrowSize - arrowSize + 1,
      marginTop: borderRadius,
      marginBottom: borderRadius,
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[data-popper-placement*="bottom"] .arrow': {
      top: 0,
      marginTop: -arrowSize - arrowSize + 1,
      // marginLeft: borderRadius,
      // marginRight: borderRadius,
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
    },
  },
  arrow: {
    zIndex: theme.zIndex.tooltip,
    position: 'absolute',
    borderColor: dark ? theme.palette.icon.dark : theme.palette.background.paper,
    borderStyle: 'solid',
    borderWidth: arrowSize,
  },
  content: {
    borderRadius,
    margin: 0,
    padding: theme.spacing(2),
  },
}));

const QPopper = (props) => {
  const { modifiers, onClickAway, className, style, arrowPadding, dark, ...otherProps } = props;
  const { classes, cx } = useStyles(props);
  const [arrowRef, setArrowRef] = useState();

  return props.anchorEl ? (
    <Popper
      className={classes.popper}
      keepMounted={false}
      disablePortal={false}
      sharedcomponentid='Q_POPPER'
      placement='auto'
      modifiers={[
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'right', 'bottom', 'left'],
          },
        },
        {
          name: 'arrow',
          enabled: true,
          options: {
            element: arrowRef,
            padding: arrowPadding ?? 20,
          },
        },
        ...(modifiers ?? []),
      ]}
      {...otherProps}
      transition
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={onClickAway}>
          <Zoom {...TransitionProps} timeout={200}>
            <div>
              <span className={cx(classes.arrow, 'arrow')} ref={(ref) => setArrowRef(ref)} />
              <Paper elevation={0} className={cx(classes.content, props.className)}>
                {props.children}
              </Paper>
            </div>
          </Zoom>
        </ClickAwayListener>
      )}
    </Popper>
  ) : null;
};

QPopper.propTypes = {
  anchorEl: PropTypes.object,
  modifiers: PropTypes.array,
  children: PropTypes.any,
  open: PropTypes.bool,
  onClickAway: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  dark: PropTypes.bool,
  arrowPadding: PropTypes.any,

  // ferry props
  placement: PropTypes.string,
  onKeyDown: PropTypes.func,
};

export default QPopper;
